var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperApprovedMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 35,
    viewBox: "0 0 27 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_352_8977)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.86894 27.8129H6.37109L6.45965 18.9805H9.95749L9.86894 27.8129Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94098 20.4483C9.94098 19.7054 10.1355 19.198 10.6242 18.6259C10.6242 18.6259 12.1843 17.1233 12.6453 16.5714C12.9839 16.1667 13.0959 15.6248 13.0959 15.2429L13.1115 13.8269C13.1115 13.2035 13.523 12.739 14.1664 12.739H14.1985C15.2264 12.7037 16.1623 13.9304 16.2404 15.1663C16.3515 16.9315 15.5719 17.9268 15.0684 18.5771C14.9434 18.7395 15.0649 18.9684 15.2733 18.9684H19.0871C19.8285 18.9684 20.5439 19.5506 20.583 20.2691C20.6238 21.0212 20.0395 21.6506 19.2877 21.712C19.2477 21.7153 19.2868 21.717 19.2903 21.717C19.8624 21.7221 20.3816 22.1226 20.4389 22.6745C20.5022 23.2853 20.0334 23.8053 19.4283 23.8498C19.3997 23.8524 19.417 23.854 19.4431 23.8557C19.9232 23.8894 20.3529 24.2175 20.4302 24.6803C20.5274 25.2608 20.1072 25.7673 19.5464 25.8346C19.5047 25.8396 19.49 25.859 19.5247 25.8691C19.9596 26.0037 20.2687 26.4126 20.2357 26.8863C20.2001 27.3986 19.6766 27.8117 19.147 27.8117H9.86719L9.94098 20.4483Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2235 32.7594C26.2235 33.6584 25.4948 34.3872 24.5958 34.3872H2.3602C1.4612 34.3872 0.732422 33.6584 0.732422 32.7594V8.93331C0.732422 8.55198 0.866303 8.18275 1.11071 7.89003L6.6202 1.29153C6.92948 0.921128 7.38716 0.707031 7.8697 0.707031H24.5958C25.4948 0.707031 26.2235 1.43582 26.2235 2.33482V32.7594Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36424 0.945312V6.87558C7.36424 7.77829 6.62966 8.5086 5.72697 8.50334L0.982422 8.47571",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_352_8977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 35,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperApprovedMobile);
export default __webpack_public_path__ + "static/media/PaperApprovedMobile.df95eaecc1f779945021f63934e6454c.svg";
export { ForwardRef as ReactComponent };